import * as Stimulus from "@hotwired/stimulus"

const activityEvents = [
    "mousemove",
    "keydown",
    "click",
    "scroll",
    "touchstart",
]

export class IdleRedirectController extends Stimulus.Controller {
    static values = {
        delay: { type: Number, default: 120000 },
        enabled: { type: Boolean, default: false },
        url: String,
    }

    connect() {
        this.reset = this.reset.bind(this)

        if (!this.enabledValue || !this.hasUrlValue) return

        activityEvents.forEach(eventName => {
            document.addEventListener(eventName, this.reset, false)
        })
        this.reset()
    }

    disconnect() {
        window.clearTimeout(this.timer)
        activityEvents.forEach(eventName => {
            document.removeEventListener(eventName, this.reset, false)
        })
    }

    reset() {
        window.clearTimeout(this.timer)
        this.timer = window.setTimeout(() => {
            window.location.assign(this.urlValue)
        }, this.delayValue)
    }
}
